import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import { toastHelper } from '../../../util/toastHelper'

const roles = [
    'Bride',
    'Groom',
	'Marrier'
    // 'Wedding planner'
]

function WelCome({
	open,
	handleClose,
	handleNext,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			modalImage="/images/GuestCount.jpg"
		>
			<div className={styles.welcomeModal}>
				<div className={styles.welcomeModalBody}>
					<h2>Select your role</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{roles.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										data-cy={`role-button-${label.toLowerCase()}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.role === label
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.role === label
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												role: label,
											})
										}
									>
										{label}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-lets-go"
					onClick={() => {
						if (!weddingData.role)
							return toastHelper('Please select a role', 'error')
						handleNext()
					}}
				>
					Let’s Go!
				</ButtonCustom>
			</div>
		</NewWedingModal>
	)
}

export default WelCome
